module.exports = __webpack_public_path__ + "static/media/man.df2bff32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/man.jpg
// module id = 23
// module chunks = 0